import PhotoSwipeLightbox from 'photoswipe/lightbox'

import { lockScroll, unlockScroll } from './scrollLock'

/**
 * PhotoSwipe lightbox for any gallery marked `.js-lightbox`. Each openable item
 * is an `a.js-lightbox-item` whose href points at the full image; PhotoSwipe
 * reads its `data-pswp-width` / `data-pswp-height`. The core module is imported
 * lazily, so its weight only loads the first time a lightbox opens.
 *
 * @param {import('lenis').default|null} [lenis] - smooth-scroll instance to
 *   pause while the lightbox is open. Omit/null when reduced motion left Lenis
 *   disabled (we then lock native scroll instead).
 */
export function initLightbox(lenis = null) {
  document.querySelectorAll('.js-lightbox').forEach((gallery) => {
    const lightbox = new PhotoSwipeLightbox({
      gallery,
      children: 'a.js-lightbox-item',
      pswpModule: () => import('photoswipe'),
    })

    // If width/height weren't provided up front (e.g. a future gallery source
    // omits them), derive them from the already-loaded thumbnail — object-cover
    // crops the display box but leaves the image's naturalWidth/Height intact,
    // and the thumbnail is the same file the href points at.
    lightbox.addFilter('domItemData', (itemData, element) => {
      if (!itemData.width || !itemData.height) {
        const img = element?.querySelector('img')
        if (img?.naturalWidth) {
          itemData.width = img.naturalWidth
          itemData.height = img.naturalHeight
        }
      }
      return itemData
    })

    lightbox.on('beforeOpen', () => lockScroll(lenis))
    lightbox.on('destroy', () => unlockScroll(lenis))

    lightbox.init()
  })
}
